import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  margin-top: 16px;

  .container-btn-selecionar-parcela input {
    margin-right: 20px;
  }

  @media (max-width: 768px) {
    display: block;

    .container-btn-selecionar-parcela {
      position: relative;
      top: 40px;
    }
  }
`;

export const CardContainer = styled.div`
  background: #fff;
  border: 2px solid
    ${({ vencida, tema, temCartao, temPix }) =>
      !vencida && !temPix
        ? tema.primaryColor
        : temCartao || temPix
        ? '#d1d1d1'
        : '#ba122b'};
  border-radius: 5px;

  padding: 8px 16px;
  box-sizing: border-box;
  align-items: center;
  min-height: 64px;

  width: 100%;
  display: flex;

  .field {
    display: flex;
    width: 100%;
    font-size: 12px;
    color: #4d4d4d;
    gap: 4px;
  }

  .divider {
    width: 2px;
    min-height: 100%;
    background-color: #f0f0f0;
    margin: 0 24px;
    align-self: normal;
  }
  .color {
    color: ${(props) => props.tema.primaryColor};
  }

  .field {
    font-size: 12px;
    color: #4d4d4d;
  }

  .first-section {
    display: flex;
    width: 40%;
    justify-content: space-between;
    align-items: center;

    box-sizing: border-box;

    .field:nth-child(2) {
      gap: 0;
    }

    .icone-erro-boleto {
      width: 50px;
      margin-right: 20px;
    }

    .icon-container {
      background-color: ${({ vencida, tema, temCartao, temPix }) =>
        !vencida && !temPix
          ? tema.primaryColor
          : temCartao || temPix
          ? '#d1d1d1'
          : '#ba122b'};

      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      height: 36px;
      min-width: 36px;
      box-sizing: border-box;
      margin-right: 24px;
      margin-left: 2px;

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
      }

      svg:not(.btnDownloadArrow) {
        fill: #fff !important;
      }

      #Grupo_1411 {
        path,
        rect {
          fill: #fff !important;
        }
      }

      svg.btnDownloadArrow {
        fill: ${({ vencida, tema, temCartao, temPix }) =>
          !vencida && !temPix
            ? tema.primaryColor
            : temCartao || temPix
            ? '#d1d1d1'
            : '#ba122b'};

        margin-left: 15px;
        position: absolute;
        right: -20px;
        top: -15px;
        background-color: #fff;
        border-radius: 50%;
      }
    }

    .container-fields {
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 20px;

      .field {
        flex-direction: column;

        .description {
          font-size: 14px;
          font-weight: bold;

          letter-spacing: 0;
        }

        .value {
          display: block;
          margin-top: 4px;
          font-size: 14px;
          font-weight: bold;
          color: ${({ vencida, tema, temCartao, temPix }) =>
            !vencida && !temPix
              ? tema.primaryColor
              : temCartao || temPix
              ? '#4d4d4d'
              : '#ba122b'};
        }
      }
    }
  }

  .second-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 25%;
    height: 36px;
    gap: 6px;
    box-sizing: border-box;

    .field {
      display: flex;
      justify-content: space-between;
    }
  }
  .third-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30%;
    text-align: end;
    gap: 8px;
    .field-title {
      width: 100%;
    }

    .processing-message {
      color: ${({ tema }) => tema.primaryColor};
      font-weight: bold;
      display: block;
      margin-bottom: 4px;
      font-size: 14px;
    }

    .field {
      display: flex;
      justify-content: space-between;
      text-align: end;
    }
    .vencimento {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 4px;
      color: ${({ vencida, tema }) =>
        !vencida ? tema.primaryColor : '#ba122b'};
    }
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: baseline;
    align-items: baseline;
    gap: 12px;

    .first-section {
      display: flex;
      flex-flow: column;
      align-items: start;
      gap: 12px;
    }

    .first-section,
    .second-section,
    .third-section {
      width: 100%;
    }

    .divider {
      width: 100%;
      min-height: 2px;
      margin: 0;
    }

    .third-section {
      position: relative;
      top: 0;
    }

    .field {
      width: auto;
    }
  }
`;

export const MsgParcelaBloqueada = styled.p`
  margin-top: 0;
  font-size: 12px;
  color: #4d4d4d;
  left: 50px;
  position: relative;
  @media (max-width: 768px) {
    left: 0;
  }
`;

export const MsgErroBoleto = styled.p`
  font-size: 12px;
  color: #ba122b;
  margin-left: 40px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`;
